export type CooperationEndSettlementState = "notApplicable" | "pending" | "settled";

export function formatCalendarDate(value: string | null | undefined): string {
  if (!value) {
    return "";
  }

  const [year, month, day] = value.slice(0, 10).split("-");
  if (!year || !month || !day) {
    return value;
  }

  return `${day}.${month}.${year}`;
}

export function formatSettledAt(value: string | null | undefined): string {
  if (!value) {
    return "";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function clearanceStatusText(
  state: CooperationEndSettlementState | null | undefined,
  settledAt: string | null | undefined,
  settledByName: string | null | undefined
): string {
  if (state === "settled") {
    const who = settledByName ? `, ${settledByName}` : "";
    return `Obiegówka: rozliczona ${formatSettledAt(settledAt)}${who}`;
  }

  if (state === "pending") {
    return "Obiegówka: do rozliczenia";
  }

  return "Obiegówka: nie dotyczy";
}

export function delayedAcceptanceStatusText(
  state: CooperationEndSettlementState | null | undefined,
  settledAt: string | null | undefined,
  settledByName: string | null | undefined
): string {
  if (state === "settled") {
    const who = settledByName ? `, ${settledByName}` : "";
    return `Odroczony odbiór: rozliczony ${formatSettledAt(settledAt)}${who}`;
  }

  if (state === "pending") {
    return "Odroczony odbiór: do rozliczenia";
  }

  return "Odroczony odbiór: nie dotyczy";
}
